import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function allowedProductPropertiesFilters(taxon, productProperties) {
  let allowedProductProperties = productProperties;
  const allowedFiltersNames = taxon.properties_whitelist;
  const disallowedFiltersNames = taxon.properties_blacklist;
  
  if (allowedFiltersNames.length !== 0) {
    allowedProductProperties = allowedProductProperties.filter((pp) =>
      allowedFiltersNames.includes(pp.name)
    );
  }

  if (disallowedFiltersNames.length !== 0) {
    allowedProductProperties = allowedProductProperties.filter(
      (pp) => !disallowedFiltersNames.includes(pp.name)
    );
  }

  return allowedProductProperties;
}
